import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook to scroll to top on route change or manually trigger scroll to top.
 * @param auto - if true, scrolls to top on route change
 */
export const useScrollToTop = (auto = true) => {
  const location = useLocation();

  useEffect(() => {
    if (auto) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [auto, location]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return { scrollTop };
};
